var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#3186E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 9.66669C13.3993 9.66669 9.66602 13.4 9.66602 18C9.66602 22.6 13.3993 26.3334 17.9993 26.3334C22.5993 26.3334 26.3327 22.6 26.3327 18C26.3327 13.4 22.5993 9.66669 17.9993 9.66669ZM17.9993 22.1667C17.541 22.1667 17.166 21.7917 17.166 21.3334V18C17.166 17.5417 17.541 17.1667 17.9993 17.1667C18.4577 17.1667 18.8327 17.5417 18.8327 18V21.3334C18.8327 21.7917 18.4577 22.1667 17.9993 22.1667ZM18.8327 15.5H17.166V13.8334H18.8327V15.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.cc5e6625cf46733d74b5ea2a5a7a25aa.svg";
export { ForwardRef as ReactComponent };